hash-files/files=[
  {
    path: "index.marko",
    content:
      "<let/count=0>\n<button onClick() { count++ }>\n  ${count}\n</button>\n",
  },
]

playground files:=files
